import { STANDARD_JOURNEY_PRINT_ENGLISH } from '../data/standardJourneyPrintCopy.js';
import { professionalTranslationFor } from '../data/professionalTranslationRuntime.js';
import { sourceRevision } from './translationAssurance.js';

// These are patient-facing *print document* labels, not Studio-only controls.
// The same labels are used for both Standard and Large Text formats.
export function buildStandardJourneyPrintTranslationRows(locale) {
  return Object.entries(STANDARD_JOURNEY_PRINT_ENGLISH).map(([key, sourceText]) => {
    const id = 'standardJourneyPrint:' + key;
    const translation = professionalTranslationFor(locale, 'standardJourneyPrint', key) || '';
    return {
      id, namespace: 'standardJourneyPrint', path: key,
      contentArea: 'hospital_journeys', sourceText, sourceRevision: sourceRevision(id, sourceText),
      originalText: locale === 'en' ? sourceText : translation,
      provenance: translation ? 'professionally approved correction' : locale === 'en' ? 'English print source' : 'not translated',
      publicationTarget: 'locale',
    };
  });
}
